import { SalesStatsResult } from "../../dto/reports.dto";
import { CategoryBar } from "../tremor/CategoryBar";
import { EmptyState } from "./EmptyState";

interface SalesCardProps {
  data: SalesStatsResult;
}

function formatNumber(value: number) {
  return new Intl.NumberFormat("id-ID").format(value);
}

export function SalesCard({ data }: SalesCardProps) {
  const cntSales = parseFloat(data.count_sales || "0");
  const cntRefund = parseFloat(data.count_refund || "0");
  const total = cntSales + cntRefund;
  return (
    <div className="bg-white p-8 rounded-md border border-gray-200">
      <dt className="font-medium text-gray-900 sm:text-sm">
        Total Transactions
      </dt>
      <dd className="mt-2 text-2xl font-semibold text-gray-900">
        {formatNumber(total)}
      </dd>
      {total > 0 ? (
        <>
          <CategoryBar
            values={[cntSales, cntRefund]}
            className="mt-6"
            colors={["blue", "red"]}
            showLabels={false}
          />
          <ul className="mt-4 flex flex-wrap gap-x-10 gap-y-4 text-sm">
            <li>
              <span className="text-base font-semibold text-gray-900">
                {formatNumber(cntSales)}
              </span>
              <div className="flex items-center gap-2">
                <span
                  className="size-2.5 shrink-0 rounded-sm bg-blue-500"
                  aria-hidden="true"
                />
                <span className="text-sm">Sales</span>
              </div>
            </li>
            <li>
              <span className="text-base font-semibold text-gray-900">
                {formatNumber(cntRefund)}
              </span>
              <div className="flex items-center gap-2">
                <span
                  className="size-2.5 shrink-0 rounded-sm bg-red-400"
                  aria-hidden="true"
                />
                <span className="text-sm">Refund</span>
              </div>
            </li>
          </ul>
        </>
      ) : (
        <EmptyState />
      )}
    </div>
  );
}
